export const TRACKER_ADDTOCART = 'AddToCart'
export const TRACKER_ADDTOWISHLIST = 'ProdFavAdd'
export const TRACKER_PRODS_DELETE = 'Prods-Delete'
export const TRACKER_PRODS_CHANGE_UPC = 'Prods-Update'
export const TRACKER_SEARCH_LINK = 'link'
export const TRACKER_SEARCH_PAGE_READY = 'SearchPageReady'
export const TRACKER_SEARCH_PRODUCTS = 'products'
export const TRACKER_SEARCH_RESULTS_LINK = 'SearchPanel_Results_link'
export const TRACKER_SEARCH_RESULTS_QUERY = 'SearchPanel_Results_query'
export const TRACKER_SEARCH_RESULTS_SERB = 'SERB'
export const TRACKER_SEARCH_SUGGESTED = 'suggested'
export const TRACKER_SEARCH_SUPPORT = 'support'
export const TRACKER_SEARCH_TEXT = 'text'
export const TRACKER_MINI_WISHLIST_OVERLAY_OPEN = 'MiniWishOverlay-Open'
export const TRACK_MINI_CART_OVERLAY_OPEN = 'MiniCartOverlay-Open'
export const TRACKER_OPEN_VIRTUAL_MIRROR = 'VirtualMirror'
export const TRACKER_CHECKOUT_STEP_GATEWAY = 'Checkout-Step-Gateway'
export const TRACKER_COUNTRY_SELECTOR_OVERLAY = 'X_X_FlagOverlay_CountrySelector'
export const TRACKER_SUBMIT_NEWSLETTER = 'SignupForm'
export const TRACKER_EMAIL_ME = 'EmailMeWhenAvailable'
export const TRACKER_LOADING_READY = 'Loading-Ready'
export const TRACKER_HIDDEN_ACTION = 'hiddenaction'
export const TRACKER_CLICK = 'Click'
export const TRACKER_ERROR = 'Error'
export const TRACKER_ERROR_CODE_SIGNUP = 'Signup'
export const TRACKER_ERROR_CODE_PDP = 'Pdp'
export const TRACKER_ERROR_SOURCE_USER = 'User'
export const TRACKER_ERROR_SOURCE_404 = '404'
export const TRACKER_ERROR_SOURCE_SERVER = 'Server'
export const TRACKER_ERROR_SOURCE_CLIENT = 'Client'
export const TRACKER_ERROR_SOURCE_PRODUCT = 'Product'
export const TRACKER_ERROR_SOURCE_ANOMALY = 'Anomaly'
export const TRACKER_EVENT = 'Event'
export const TRACKER_STORE_LOCATOR_SEARCH_RESULTS = 'Exam-Funnel-FindStoreResults'
export const TRACKER_INSURANCE_TENTATIVE = 'Insurance-Tentative'
export const TRACKER_INSURANCE_APPLIED = 'Insurance-Applied'
export const TRACKER_EYEMED = 'Eyemed'
export const TRACKER_INSURANCE = 'Insurance'
export const TRACKER_INSURANCE_BENEFITS = 'frames,lenses'
export const TRACKER_FIT_GLASSES = 'FitGlasses'
export const TRACKER_VM_RENDER = 'Render'
export const MIX_AND_MATCH_BUTTON = 'X_X_LensPanelMixmatch'
export const PROD_CUSTOMIZE = 'X_X_Prod_Customize'
export const TILES_CUSTOMIZE = 'X_X_Tiles_Customize'
export const LENS_TYPE_DEFAULT = 'PLANO'
export const PROD_GEOFIT = 'X_X_Prod_Geofit'
export const PROD_ADDLENS = 'X_X_Prod_AddLens'
export const PROD_SIZEFITGUIDEPANEL = 'X_X_Prod_SizeFitGuidePanel'
export const PROD_ADDCART = 'X_X_Prod_AddCart'
export const STICKYBAR_ADDLENS = 'X_X_Stickybar_AddLens'
export const PROD_LOGINTOSHOP = 'X_X_Prod_LoginToShop'
export const PROD_EMAILMEWHENAVAILABLE = 'X_X_Prod_EmailMeWhenAvailable'
export const PROD_FINDOTHERSTYLE = 'X_X_Prod_FindOtherStyle'
export const PROD_FINDSTORE = 'X_X_Prod_FindStore'
export const PROD_FINDSTORE_OPEN = 'X_X_Prod_FindStoreOpen'
export const PROD_POLARIZED = 'X_Pdp_Prod_Polarize_Toggle'
export const PROD_MINICART_ADDCART = 'X_X_MiniCartOverlay_AddCart'
export const PROD_FAST_DELIVERY = 'X_X_Prod_FastDelivery'
export const PROD_ACCORDION = 'X_X_Prod_Accordion'
export const PROD_ADD_TO_WISHLIST = 'X_Pdp_Prod_AddToWishList'
export const NAV_SEARCH = 'MainNav_Search_Open'
export const NAV_BAG = 'X_X_MainNav_Bag'
export const NAV_MYACCOUNT = 'X_X_MainNav_Account'
export const PROD_VIRTUAL_MIRROR_START = 'X_X_Prod_VMStart'
export const PROD_ALSO_LIKE = 'X_X_AlsoLike'
export const MINI_CART_OVERLAY_TILES = 'X_X_MiniCartOverlay'

export const ALGOLIA_LANDING_PDP_TEALIUM_ACCOUNT = 'luxottica'
export const ALGOLIA_LANDING_PDP_TEALIUM_PROFILE = 'ray-ban'
export const ALGOLIA_LANDING_PDP_TEALIUM_DATASOURCE = 'mq7b3h'
export const ALGOLIA_LANDING_PDP_TEALIUM_EVENT = 'algolia'

export const CART_KLARNA_EXPRESS_CHECKOUT = 'X_X_Cart_KlarnaExpressCheckout'
export const KLARNA_EXPRESS_CHECKOUT = 'KlarnaExpressCheckout'
export const BOTTOM_LINKS = 'BottomLinks'
export const PROD_COLOR_THUMBS = 'Prod_ColorThumbs'
export const PROD_SIZE_CHANGE = 'Prod_SizeChange'
export const PROD_SIZE_GUIDE = 'Prod_SizeGuide'
export const PROD_TRY_LENSES = 'Prod_TryLenses'
export const CHECK_GIFT_CARD_BALANCE = 'Prod_CheckGiftCardBalance'
